
module.exports = require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/index.js
 ** module id = 40
 ** module chunks = 0
 **/